module.exports = __webpack_public_path__ + "img/tv-162x230.b9fd1e80.jpg";